export enum ELogLevel {
	debug = "debug",
	log = "log",
	info = "info",
	warn = "warn",
	error = "error",
	action = "action"
}